import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { ToastService } from '@services';
import { AuthService } from '@services';
import { Router } from '@angular/router';
import { asyncLoading } from '@decorators';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';
import { persistAuthSession } from './persist-auth-session';
export { Permissions } from './persist-auth-session';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  token: string;
  readonly signupRoute = environment.zohoSignupEnabled ? '/signup' : '/register';

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastService: ToastService) {
    this.token = localStorage.getItem('token');
  }

  ngOnInit(): void {
    this.onInitForm();
    this.token ? this.router.navigate(['/app/loads/active']) : this.authService.logout();
  }

  onInitForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', Validators.required]
    });
  }

  goToForgotPassword() {
    this.router.navigate(['/forgot-password'])
  }

  @asyncLoading()
  login() {
    this.loginForm.markAllAsTouched();
    if (this.loginForm?.valid) {
      const credentials = { ...this.loginForm.value }
      this.authService.login(credentials).subscribe(response => {
        if (!response.status) {
          Swal.fire('User not verified', response.message, 'info')
        } else {
          this.saveData(response);
          this.toastService.showToast(`Welcome ${localStorage.getItem('name')}`, 'left');
          setTimeout(() => {
            response.data.user.role === 'superadmin' ? this.router.navigate(['/app/admin/companies']) : this.router.navigate(['/app/loads/active'])
          }, 500);
        }
      },
        error => {
          console.log(error);
          const message = error?.error?.message || 'Error';
          // M5.5: Suspended billing copy is longer — show dialog so it stays readable.
          if (
            typeof message === 'string' &&
            message.toLowerCase().includes('suspended due to billing')
          ) {
            this.showSuspendedDialog(message);
          } else {
            this.toastService.showToast(message, 'left');
          }
        }
      );
    } else {
      this.toastService.showToast('Invalid credential', 'left')
    }
  }

  private showSuspendedDialog(message: string) {
    const portalUrl = environment.zohoPortalUrl;
    if (!portalUrl) {
      Swal.fire('Account suspended', message, 'warning');
      return;
    }
    Swal.fire({
      title: 'Account suspended',
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Open billing portal',
      cancelButtonText: 'Close',
      footer: "First time? Accept the Zoho Billing invitation email to set your portal password, then sign in with your company's billing email.",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) window.location.assign(portalUrl);
    });
  }

  saveData({ data }: { data: UserData }) {
    persistAuthSession({ data });
  }
}

interface UserData {
  accessToken: string;
  user: {
    companyId: string;
    createdAt: Date;
    customerKey: string;
    email: string;
    firstName: string;
    isActive: boolean;
    lastName: string;
    phone: string
    role: string
    serviceKey: string;
    updatedAt: Date;
    userName: string;
    picture: string;
    _id: string;
    otherShipmentReadOnly: boolean;
    canSeeOtherShipment: boolean;
    canManageBilling?: boolean;
    primaryUser?: boolean;
    isBookable: boolean
  }
}
